import axios from 'axios';
import store from '../vuex/store.js';
import router from '../router/index.js';
// 登录请求方法
const loginreq = (method, url, params) => {

 return  axios.post(url, params)
    .then(response => {
     /* console.log(response.data) */
      return response;
    })
    .catch(error => {
      console.error('Error:', error);
    });

  //return ;
/*  return axios.post(url, params)
    .then(res => res.data)
    .catch(error => {
      console.error('Error:', error);
    });
 */
    //return ;
   /* return axios({
        method: method,
        url: url,
        headers: {
           "Content-Type": "application/json;charset=utf-8"
        },
        data: sss,
       // traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data); */
};
// 通用公用方法
const req = (method, url, params) => {

  if(method.toLowerCase() === 'get'){

    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' +localStorage.getItem('logintoken')
        },
        params: params,
    }).then(res => {
      if(res.data.code == -1 || res.data.code == 401 || res.data.code == 403 ){
        store.dispatch('userout')
        router.push({ path: '/login' })
      }
      return res.data
    });
  }else{
    const config = {
      method: method,
      url: url,
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' +localStorage.getItem('logintoken')
        },
      data: params
    };

    // 发送请求
   return axios(config)
    .then(function (response) {
     // console.log(response)
     // console.log(JSON.stringify(response.data));
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
    /* return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' +localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data); */
  }

}

export {
    loginreq,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js